var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-config"},[_c('a',{staticClass:"item",attrs:{"value":_vm.value},on:{"click":($event) => _vm.$emit('update', $event.target.value)}},[_c('i',{staticClass:"icon-search"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }